import script from "./hmbj.vue?vue&type=script&setup=true&lang=js"
export * from "./hmbj.vue?vue&type=script&setup=true&lang=js"

import "./hmbj.vue?vue&type=style&index=0&id=1b5d2473&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b5d2473"]])

export default __exports__